export type LandingEvent =
  | "hero_cta_selected"
  | "intention_option_selected"
  | "compatibility_interaction_completed"
  | "encounter_demo_used"
  | "encounter_match_completed"
  | "safety_section_viewed"
  | "availability_viewed"
  | "availability_selected";

// Consent-neutral integration point: no network request and no sensitive values.
export function trackLandingEvent(name: LandingEvent) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("vowent:landing-event", { detail: { name } }));
}
